import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DyeingColor } from '../../models/item/lab-dip';

import { searchColorByFabric } from '../../models/lab-dip-request/search-color';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class LabDipRequestProxyService {
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip-request';

  private readonly httpClient = inject(HttpClient);

  public getCustomerColors(customerReference: string): Observable<ApiResponse<DyeingColor[]>> {
    return this.httpClient.get<ApiResponse<DyeingColor[]>>(`${this.baseUrl}/${customerReference}/colors`);
  }

  public getColorByFabric(term: searchColorByFabric): Observable<ApiResponse<DyeingColor[]>> {
    return this.httpClient.post<ApiResponse<DyeingColor[]>>(`${this.baseUrl}/color/search`, {
      customerReference: term.customerReference,
      fabricCode: term.fabricCode,
      colorName: term.colorName,
    });
  }
}
